import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';

import { Link } from 'components/AORedesign';
import { handlePdfDownload } from 'components/CommonUtilityServices/DownloadPdfService';
import { redirectUrlFunction } from 'components/CommonUtilityServices/RedirectService';

import { GET_TAR_FORMS_URL, GET_TAR_GEN_REPORT_URL, GET_TAR_URL } from 'constants/api';
import { ROUTE_BILLING_DETAILS } from 'constants/routes';

import { getMSEMSCPRedirectRequestBody, sendGetPolicyInquiry } from 'components/CommercialLinesServices/CLSPolicyInquiry';
import { sendGetMSEMSCPlusPolicyInquiry } from 'components/CommercialLinesServices/cls-utis';
import { handleFarmRanchRedirect } from 'components/Workflow/WorkflowCardFarmRanch';

const periodMenuItems = [
  { label: 'Previous Day', value: 0 },
  { label: 'Previous Week', value: 6 },
  { label: 'Previous Month', value: 30 },
  { label: 'Custom Dates', value: -1 },
];

const handleClickOpenPolicy = (params, setReportError) => {
  if (params.row.PolicySystem === 'PL MSS' || isE1pPolicy(params.row)) {
    // if it is E1P policy, make effective date to current date
    const effDate = isE1pPolicy(params.row) ? new Date() : new Date(params.row.EffectiveDate);
    const effDateFormatted = moment(effDate).format('MM/DD/YYYY');
    const request_body = {
      Area: 'Personal Lines',
      TypeOfRedirect: 'View / Change Policy',

      DetailedContext: [
        {
          name: 'effectiveDate',
          value: effDateFormatted,
        },
        {
          name: 'policyNumber',
          value: params.row.PolicyNumber,
        },
        {
          name: 'vendorSystem',
          value: false,
        },
      ],
    };
    return redirectUrlFunction(request_body, 'POST', null, setReportError);
  } else if (params.row.PolicySystem === 'CL MSS') {
    const request_body_for_policy_inquiry = {
      // inquiryDate: viewPolicyAsOfDate,
      inquiryType: 'Policy Inquiry',
      policyNumber: params.row.PolicyNumber,
    };
    // Call Proxy Policy Inquiry to get data for request body
    sendGetPolicyInquiry(
      request_body_for_policy_inquiry,
      () => {},
      () => {},
      () => {},
    )
      .then((policyInquiryPayload) => {
        if (!_.isNil(policyInquiryPayload?.data?.policyNumber) && !_.isNil(policyInquiryPayload?.data?.acctType)) {
          const effDate = new Date(params.row.EffectiveDate);
          const effDateFormatted = moment(effDate).format('MM/DD/YYYY');
          const request_body = {
            Area: 'Commercial Lines',
            TypeOfRedirect: 'MSS Policy Inquiry',
            DetailedContext: [
              {
                name: 'transactionId',
                value: policyInquiryPayload?.data?.policyInquiryInfo?.systemAssignId,
              },
              {
                name: 'accountType',
                value: 'SEARCHVP',
              },
              {
                name: 'effectiveDate',
                value: effDateFormatted,
              },
            ],
          };
          return redirectUrlFunction(request_body, 'POST', null, setReportError);
        } else if (setReportError) {
          setReportError('An error occurred while redirecting to the policy. Please try again.');
        }
      })
      .catch(() => {
        if (setReportError) setReportError('An error occurred while redirecting to the policy. Please try again.');
      });
  }
};

const handleRedirectToMSE = (params, setReportError) => {
  sendGetMSEMSCPlusPolicyInquiry(
    params.row.PolicyNumber,
    () => {},
    () => {},
    () => {},
  )
    .then((clmsePolicyPayload) => {
      // Ensure data structure exists and populate with fallback from params.row
      const enrichedPayload = {
        ...clmsePolicyPayload,
        data:
          clmsePolicyPayload?.data?.length > 0
            ? clmsePolicyPayload.data
            : [
                {
                  policyNumber: params.row?.PolicyNumber,
                  agencyId: params.row?.AgencyCode,
                },
              ],
      };

      const redirect_request_body = getMSEMSCPRedirectRequestBody(enrichedPayload);

      redirectUrlFunction(redirect_request_body, 'POST', null, setReportError);
    })
    .catch(() => {
      if (setReportError) setReportError('An error occurred while redirecting to the policy. Please try again.');
    });
};

const renderCell = (params, setSelectedClaim, history, setPreviousPageName, setReportError) => {
  if (!_.isNil(params.row)) {
    // if it is a policy transaction, redirect to policy admin system
    if (params.row.ActivityType === 'Policy' && (params.row.PolicySystem === 'CL MSS' || params.row.PolicySystem === 'PL MSS' || isE1pPolicy(params.row))) {
      return (
        <Link
          aria-label="policy-number-show-more"
          onClick={() => {
            handleClickOpenPolicy(params, setReportError);
          }}
          color="primary">
          {params.value}
        </Link>
      );
    } else if (params.row.ActivityType === 'Policy' && isMsePolicy(params.row)) {
      return (
        <Link onClick={() => handleRedirectToMSE(params, setReportError)} color="primary">
          {params.value}
        </Link>
      );
    } else if (params.row.ActivityType === 'Policy' && isFarmRanchPolicy(params.row)) {
      return (
        <Link onClick={() => handleFarmRanchRedirect(setReportError)} color="primary">
          {params.value}
        </Link>
      );
    }
    // if it is a claim transaction, go to claims inquiry
    else if (params.row.ActivityType === 'Claim') {
      const { PolicyNumber, ClaimsOccurrence } = params.row;

      return (
        <Link onClick={() => setSelectedClaim({ policyNumber: PolicyNumber, occurrenceNumber: ClaimsOccurrence })} color="primary">
          {params.value}
        </Link>
      );
    }
    // all others go to billing details
    else {
      return (
        <Link onClick={() => handleOnRowDoubleClick(params, history, setPreviousPageName, setSelectedClaim, setReportError)} color="primary">
          {params.value}
        </Link>
      );
    }
  }
};

const handleOnRowDoubleClick = (params, history, setPreviousPageName, setSelectedClaim, setReportError) => {
  if (params.row.ActivityType === 'Policy' && (params.row.PolicySystem === 'CL MSS' || params.row.PolicySystem === 'PL MSS' || isE1pPolicy(params.row))) {
    handleClickOpenPolicy(params, setReportError);
  } else if (params.row.ActivityType === 'Policy' && isMsePolicy(params.row)) {
    handleRedirectToMSE(params, setReportError);
  } else if (params.row.ActivityType === 'Policy' && isFarmRanchPolicy(params.row)) {
    handleFarmRanchRedirect(setReportError);
  } else if (params.row.ActivityType === 'Claim') {
    const { PolicyNumber, ClaimsOccurrence } = params.row;
    setSelectedClaim({ policyNumber: PolicyNumber, occurrenceNumber: ClaimsOccurrence });
  } else {
    const accountDetailUrl = `${ROUTE_BILLING_DETAILS}/${params.row.AccountNumber}`;
    setPreviousPageName('Transaction Activity Report');
    history.push(accountDetailUrl);
  }
};

const getReportResultsColumns = (setSelectedClaim, history, setPreviousPageName, setReportError) => {
  return [
    {
      field: 'NamedInsured',
      headerName: 'Name Insured',
      sortable: true,
      width: 200,
    },
    {
      field: 'PolicyNumber',
      headerName: 'Policy Number',
      sortable: true,
      width: 200,
      renderCell: (params) => renderCell(params, setSelectedClaim, history, setPreviousPageName, setReportError),
    },
    {
      field: 'AccountNumber',
      headerName: 'Account Number',
      sortable: true,
      width: 200,
    },
    {
      field: 'LOBName',
      headerName: 'Line of Business',
      sortable: true,
      width: 200,
    },
    {
      field: 'PolicySystem',
      headerName: 'System',
      sortable: true,
      width: 200,
    },
    {
      field: 'ActivityType',
      headerName: 'Transaction Type',
      sortable: true,
      width: 200,
    },
    {
      field: 'TransactionSubType',
      headerName: 'Transaction SubType',
      sortable: true,
      width: 200,
    },
    {
      field: 'ProcessDate',
      headerName: 'Transaction Processed Date',
      sortable: true,
      width: 200,
    },
    {
      field: 'EffectiveDate',
      headerName: 'Transaction Effective Date',
      sortable: true,
      width: 200,
    },
    {
      field: 'Amt',
      headerName: 'Transaction Amount (marked credit/debit)',
      sortable: true,
      width: 200,
    },
    {
      field: 'AgencyCode',
      headerName: 'Agency Code',
      sortable: true,
      width: 200,
    },
    {
      field: 'AgencyName',
      headerName: 'Agency Name',
      sortable: true,
      width: 200,
    },
  ];
};

const fetchTAReportsFormData = async (endpoint) => {
  const tAReportsFormsUrl = `${GET_TAR_FORMS_URL}/${endpoint}`;
  const tAReportsFormsData = await axios.get(`${tAReportsFormsUrl}`);
  const tAReportsFormsMenuItems = tAReportsFormsData.data;
  return tAReportsFormsMenuItems;
};

const fetchFormSuggestions = async (endpoint, searchQuery) => {
  try {
    const tAReportsFormsUrl = `${GET_TAR_FORMS_URL}/${endpoint}/${searchQuery}`;
    const tAReportsFormsData = await axios.get(`${tAReportsFormsUrl}`);
    const tAReportsFormsSuggestion = tAReportsFormsData.data;
    return tAReportsFormsSuggestion;
  } catch (error) {
    console.error(error);
  }
};

const handleLOBOnChange = (e, lOBs, formData, setFormData) => {
  const target = e.target;
  const value = target.value;
  const name = target.name;
  const lobGroup = lOBs.find((lob) => lob.lobName === value).lobGroupName;
  setFormData({ ...formData, [name]: value, lobGroup });
};

const handleAOTransferListSetLeft = (data, setTransactionSubtypes) => {
  setTransactionSubtypes(data);
};

const handleAOTransferListSetRight = (data, formData, setFormData) => {
  setFormData({
    ...formData,
    transactionType: !data.length ? 'ALL' : '...CUSTOM SELECTIONS...',
    transactionSubTypes: data,
  });
};

const sanitizeRequestPayload = (requestBody) => {
  for (const key in requestBody) {
    if (key === 'period') {
      if (requestBody[key] === -1) {
        // Custom date
        requestBody[key] = 0;
      } else {
        // Ignore to and from date if not custom date period selected
        delete requestBody.fromDate;
        delete requestBody.toDate;
      }
    }

    // Delete empty or null values from formData
    if (requestBody[key] === null || requestBody[key] === '') {
      delete requestBody[key];
    }

    // Agency codes only takes last 6 characters (like legacy)
    if (key === 'agencyCodes' && requestBody[key]) {
      requestBody[key] = requestBody[key].slice(-6);
    }
  }
};

const handleCreateTransactionActivityReport = async (
  formData,
  setReportResults,
  generateReportFormDataRef,
  setExportRangeMenuItems,
  setExportRangeValue,
  setCreateButtonLoading,
  setReportError,
) => {
  setCreateButtonLoading(true);
  if (generateReportFormDataRef) {
    generateReportFormDataRef.current = formData;
  }
  const requestBody = { ...formData };
  sanitizeRequestPayload(requestBody);
  const tAReportsUrl = `${GET_TAR_URL}/get-data`;
  try {
    const tAReportsData = await axios.post(`${tAReportsUrl}`, requestBody);
    const pageSize = 500;
    const exportPages = Math.ceil(tAReportsData.data.total / pageSize);
    const exportRangeMenuItems = [];
    for (let i = 1; i <= exportPages; i++) {
      const endRange = Math.min(tAReportsData.data.total, i * pageSize);
      exportRangeMenuItems.push({ label: `${(i - 1) * pageSize + 1}-${endRange}`, value: i });
    }
    if (setExportRangeMenuItems) setExportRangeMenuItems(exportRangeMenuItems);
    if (setExportRangeValue) setExportRangeValue(1);
    setReportResults(tAReportsData.data.data ? tAReportsData.data : []);
  } catch {
    setReportResults({ data: [] });
    if (setReportError) setReportError('An error occurred while creating the report. Please try again.');
  }
  setCreateButtonLoading(false);
};

const handleOnSortModelChange = (sortData, generateReportFormDataRef) => {
  generateReportFormDataRef.current.sortColumn = sortData[0]?.field;
  generateReportFormDataRef.current.sortOrder = sortData[0]?.sort;
};

const getGenerateReportRequestBody = (requestBody) => {
  if (requestBody.sortColumn === undefined) {
    requestBody.sortColumn = '';
  }
  if (requestBody.sortOrder === undefined) {
    requestBody.sortOrder = '';
  }
  let detailedContext = [];
  for (const key in requestBody) {
    detailedContext.push({
      name: key,
      value: requestBody[key],
    });
  }
  return {
    Area: 'transaction-activity',
    DetailedContext: detailedContext,
    TypeOfRedirect: 'Generate-PDF',
  };
};

const handleGenerateOnClick = (generateReportFormDataRef, setLoadingPdf, setDownloadingPdfError, exportRangeValue) => {
  const requestBody = { ...generateReportFormDataRef.current, pageNumber: exportRangeValue };
  sanitizeRequestPayload(requestBody);
  let reportRequestBody = getGenerateReportRequestBody(requestBody);
  const tAReportsGenerateUrl = GET_TAR_GEN_REPORT_URL;
  handlePdfDownload('POST', reportRequestBody, tAReportsGenerateUrl, setLoadingPdf, setDownloadingPdfError, setDownloadingPdfError, 'newWindow');
};

const handleClickPaginationChange = (page, formData, setReportResults, setCreateButtonLoading) => {
  const formDataCopy = { ...formData, pageNumber: page + 1 };
  handleCreateTransactionActivityReport(formDataCopy, setReportResults, undefined, undefined, undefined, setCreateButtonLoading);
};

const handleExportDropdownOnChange = (e, setExportRangeValue) => {
  setExportRangeValue(e.target.value);
};

const isE1pPolicy = (row) => {
  const formattedPolicyNumber = (row.PolicyNumber ?? '').trim().toUpperCase();
  const formattedPolicySystem = (row.PolicySystem ?? '').trim().toUpperCase();
  return (
    formattedPolicySystem === 'E1P' ||
    formattedPolicyNumber.match(/^A[0-9]{8}$/) ||
    formattedPolicyNumber.match(/^H[0-9]{8}$/) ||
    formattedPolicyNumber.match(/^U[0-9]{8}$/)
  );
};

const isFarmRanchPolicy = (row) => {
  const formattedPolicyNumber = (row.PolicyNumber ?? '').trim().toUpperCase();
  const formattedPolicySystem = (row.PolicySystem ?? '').trim().toUpperCase();
  return formattedPolicySystem === 'FR' || formattedPolicyNumber.match(/^91[0-9]{10}$/) || formattedPolicyNumber.match(/^92[0-9]{10}$/);
};

const isMsePolicy = (row) => {
  const formattedPolicyNumber = (row.PolicyNumber ?? '').trim().toUpperCase();
  const formattedPolicySystem = (row.PolicySystem ?? '').trim().toUpperCase();
  return (
    formattedPolicySystem === 'MSE' ||
    formattedPolicyNumber.match(/^BPP[0-9]{7}$/) ||
    formattedPolicyNumber.match(/^WCP[0-9]{7}$/) ||
    formattedPolicyNumber.match(/^GLP[0-9]{7}$/)
  );
};

export {
  fetchFormSuggestions,
  fetchTAReportsFormData,
  getReportResultsColumns,
  handleAOTransferListSetLeft,
  handleAOTransferListSetRight,
  handleClickPaginationChange,
  handleCreateTransactionActivityReport,
  handleExportDropdownOnChange,
  handleGenerateOnClick,
  handleLOBOnChange,
  handleOnRowDoubleClick,
  handleOnSortModelChange,
  periodMenuItems,
};
